import { Component, input } from '@angular/core';
import { Icon, IconComponent } from '../icons';

@Component({
  selector: 'ui-card',
  standalone: true,
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  imports: [IconComponent],
})
export class CardComponent {
  readonly icon = input<Icon>();
  readonly title = input<string>();
  readonly description = input<string>();
  readonly withChevronRight = input<boolean>(true);

  readonly variant = input<'default' | 'emphasized'>('default');
}
